import { useI18n as vueUseI18n } from 'vue-i18n';
import { MessageSchema } from '@/plugins/i18n';

export function useI18n() {
  return vueUseI18n<{ message: MessageSchema }>();
}
